<template>
  <div
    tabindex="0"
    :class="[{'inline-grid grid-flow-col auto-cols-max place-items-center gap-2 text-center' : v1}, {'border border-neutral-500 rounded-lg text-center inline-flex place-items-center bg-white' : v2}]"
    @keydown="handleKeydown"
  >
    <button
      type="button"
      tabindex="-1"
      :aria-label="t('less', { quantityType: props.quantityType })"
      :class="[{'cursor-default' : props.modelValue == 0}, {'cursor-pointer' : props.modelValue >= 1}, 'touch-manipulation select-none w-[40px] h-[40px]']"
      @click="update(props.modelValue - 1)"
    >
      <UiIcon
        v-if="v1"
        src="/svg/icons/less.svg"
        width="40"
        height="40"
        :alt="t('less', { quantityType: props.quantityType })"
        :class="[{'stroke-neutral-500' : props.modelValue == 0}, {'stroke-neutral-900' : props.modelValue >= 1}, 'inline-block']"
      />
      <span v-if="v2" :class="['px-2 py-1 inline-block text-xl', {'text-neutral-500' : props.modelValue == 0}, {'text-neutral-800' : props.modelValue >= 1}]">
        -
      </span>
    </button>
    <div
      role="spinbutton"
      :aria-valuenow="props.modelValue"
      :aria-valuetext="`${props.quantityType} ${props.modelValue}`"
      :aria-valuemin="props.min"
      :aria-valuemax="props.max"
      :aria-label="props.quantityType"
      :class="[{'px-0.5 py-1 border-l border-r border-r-neutral-500 border-l-neutral-500 min-w-[26px]' : v2}, {'w-5' : v1}, 'cursor-default']"
    >
      {{ props.modelValue }}
    </div>
    <button
      type="button"
      tabindex="-1"
      :aria-label="t('more', { quantityType: props.quantityType })"
      :class="[{'cursor-default' : props.modelValue == props.max}, {'cursor-pointer' : props.modelValue !== props.max}, 'touch-manipulation select-none w-[40px] h-[40px]']"
      @click="update(props.modelValue + 1)"
    >
      <UiIcon
        v-if="v1"
        src="/svg/icons/more.svg"
        width="40"
        height="40"
        :alt="t('more', { quantityType: props.quantityType })"
        :class="[{'stroke-neutral-500' : props.modelValue == props.max}, {'stroke-neutral-900' : props.modelValue !== props.max}]"
      />
      <span v-if="v2" :class="['px-2 py-1 inline-block text-xl', {'text-neutral-500' : props.modelValue == props.max}, {'text-neutral-800' : props.modelValue !== props.max}]">
        +
      </span>
    </button>
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  modelValue: {
    type: Number,
    default: null
  },
  min: {
    type: Number,
    default: 0
  },
  max: {
    type: Number,
    default: 99
  },
  quantityType: {
    type: String,
    default: ''
  },
  design: {
    type: String,
    default: 'v1'
  }
})
const t = useTranslations('UiQuantityChanger').translate

const v1 = computed(() => props.design === 'v1')
const v2 = computed(() => props.design === 'v2')

const emit = defineEmits<{(e: 'update:modelValue', value: number): void}>()

const update = (value) => {
  if (value >= props.min && value <= props.max) {
    emit('update:modelValue', parseInt(value))
  }
}

const handleKeydown = (event) => {
  if (event.key === 'ArrowRight') {
    update(props.modelValue + 1)
  } else if (event.key === 'ArrowLeft') {
    update(props.modelValue - 1)
  }
}
</script>
